import React, { useContext, useState } from "react";
import { UserContext } from "../../../context/provider/UserProvider";
import { AuthFetch } from "../../../services/api";
import { notify } from "../../../utils/utils";

const urlBaseNeumatico = process.env.REACT_APP_TMAN_API + '/Tire'
const urlBaseGestionNeumaticos = process.env.REACT_APP_TMAN_API + '/Unit/Tire'
const urlBaseOrdenTrabajo = process.env.REACT_APP_TMAN_API + '/WorkOrder'

export const useGestionNeumaticos = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa

    const [movimientos,setMovimientos] = useState([])
    const [detalladoMovimiento,setDetalladoMovimiento] = useState([])

    const [ordenesTrabajo,setOrdenesTrabajo]= useState([])
    const [cabeceraDetalleNeumatico,setCabeceraDetalleNeumatico] = useState([])
    
    const [neumaticosSinEnlaze,setNeumaticosSinEnlaze] = useState([])
    const [neumaticoEnlazado,setNeumaticoEnlazado] = useState({})

    const [estadosNeumaticos,setEstadosNeumatico] = useState([])

    const [neumaticosPorOT,setNeumaticosPorOT] = useState([])

    const infoNeumaticoDefault = {
        codNeumatico: 0,
        codigoNeumatico: "",
        codNeumaticoEstado: 0,
        nomNeumaticoEstado: "",
        codNeumaticoMedida: 0,
        nomNeumaticoMedida: "",
        codNeumaticoMarca: 0,
        nomNeumaticoMarca: "",
        codUsuario: 0,
        medidaInterna: 0,
        medidaMedia: 0,
        medidaExterna: 0,
        presion: 0,
        profundidad: 0
    }
    const [infoNeumatico,setInfoNeumatico] = useState(infoNeumaticoDefault)
    const editarInfoNeumatico = (clave,valor) => {
        setInfoNeumatico(valorAnterior => {
            return {
                ...valorAnterior,
                [clave]: valor
            }
        })
    }
    
    const listadoMovimientoNeumaticos = async () => {
        const response = await AuthFetch({
            url: urlBaseGestionNeumaticos + '/record?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setMovimientos(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listadoDetalladoMovimiento = async (codUnidad,nroEje,nroPosicion) => {
        const response = await AuthFetch({
            url: urlBaseGestionNeumaticos + '/changes?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codUnidad: codUnidad,
                nroEje: nroEje,
                nroPosicion: nroPosicion
            })
        })
        if(response.isValid){
            setDetalladoMovimiento(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarComboOrdenTrabajo = async () => {
        const response = await AuthFetch({
            url: urlBaseOrdenTrabajo + '/combo?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setOrdenesTrabajo(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarCabeceraDetalleNeumatico = async (codUnidad) => {
        const response = await AuthFetch({
            url: urlBaseGestionNeumaticos + '?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codUnidad: codUnidad
            })
        })
        if(response.isValid){
            setCabeceraDetalleNeumatico(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarNeumaticosSinEnlaze = async () => {
        const response = await AuthFetch({
            url: urlBaseNeumatico + '/noLink?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setNeumaticosSinEnlaze(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }
    
    const consultaNeumaticoEnlazado = async (codNeumatico) => {
        const response = await AuthFetch({
            url: urlBaseNeumatico + '/linked?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                CodNeumatico: codNeumatico
            })
        })
        if(response.isValid){
            setNeumaticoEnlazado(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarNeumaticoEstado = async () => {
        const response = await AuthFetch({
            url: urlBaseNeumatico + '/states?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setEstadosNeumatico(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const editarNeumatico = async ({
        codNeumatico,
        codigoNeumatico,
        medidaInterna,
        medidaMedia,
        medidaExterna,
        presion,
        profundidad,
        codNeumaticoEstado,
        fechaRegistroActualizacion,
        codOrdenTrabajo
    }) => {
        const response = await AuthFetch({
            url: urlBaseNeumatico,
            method: 'PUT',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codNeumatico: codNeumatico,
                codigoNeumatico: codigoNeumatico,
                codUsuarioAccion: stateUser.codUsuario,
                medidaInterna: medidaInterna,
                medidaMedia: medidaMedia,
                medidaExterna: medidaExterna,
                presion: presion,
                profundidad: profundidad,
                codNeumaticoEstado: codNeumaticoEstado,
                fechaRegistroActualizacion: fechaRegistroActualizacion,
                codOrdenTrabajo: codOrdenTrabajo
            })
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const enlazarNeumaticoUnidad = async ({codUnidad,nroEje,nroPosicion,codNeumatico,fechaRegistro,codOrdenTrabajo}) => {
        const response = await AuthFetch({
            url: urlBaseGestionNeumaticos + '/link', 
            method: 'POST',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codUnidad: codUnidad,
                nroEje: nroEje,
                nroPosicion: nroPosicion,
                codNeumatico: codNeumatico,
                codUsuarioAccion: stateUser.codUsuario,
                fechaRegistro: fechaRegistro,
                codOrdenTrabajo: codOrdenTrabajo
            })
        })

        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const desenlazarNeumaticoUnidad = async ({codUnidadNeumatico,fechaRegistro,codOrdenTrabajo,comentarioDesenlace}) => {
        const response = await AuthFetch({
            url: urlBaseGestionNeumaticos + '/release',
            method: 'POST',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codUnidadNeumatico: codUnidadNeumatico,
                codUsuarioAccion: stateUser.codUsuario,
                fechaRegistro: fechaRegistro,
                codOrdenTrabajo: codOrdenTrabajo,
                comentarioDesenlace: comentarioDesenlace
            })
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const listarNeumaticosPorOT = async (codigoOT) => {
        const response = await AuthFetch({
            url: urlBaseNeumatico + '/CodigosNeumaticosPorOT?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codigoOT: codigoOT
            })
        })

        if(response.isValid){
            setNeumaticosPorOT(response.content)
        }
    }
    
    return {
        listadoMovimientoNeumaticos,
        movimientos,
        listadoDetalladoMovimiento,
        detalladoMovimiento,

        listarComboOrdenTrabajo,
        ordenesTrabajo,

        listarCabeceraDetalleNeumatico,
        cabeceraDetalleNeumatico,

        listarNeumaticosSinEnlaze,
        neumaticosSinEnlaze,
        
        consultaNeumaticoEnlazado,
        neumaticoEnlazado,

        listarNeumaticoEstado,
        estadosNeumaticos,


        infoNeumatico,
        setInfoNeumatico,
        infoNeumaticoDefault,
        editarInfoNeumatico,



        editarNeumatico,
        enlazarNeumaticoUnidad,
        desenlazarNeumaticoUnidad,

        listarNeumaticosPorOT,
        neumaticosPorOT
    }
};
